import axios from 'axios';
import {GithubAuthProvider, GoogleAuthProvider, getAuth , signInWithRedirect} from "firebase/auth"; //, signInWithPopup
import { initializeApp } from 'firebase/app';
import { api_link } from './redirect_url';
import {get} from './get_country';


function config(){
    let firebaseConfig = {
        apiKey: process.env.REACT_APP_APIKEY,
        authDomain: process.env.REACT_APP_AUTHDOMAIN,
        projectId: process.env.REACT_APP_PROJECTID,
        storageBucket: process.env.REACT_APP_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_APPID,
        measurementId: process.env.REACT_APP_MEASUREMENTID
        
    }


    return firebaseConfig;

}


export function authentication(){

    // Initialize Firebase
    const app = initializeApp(config());
  
    const provider = new GoogleAuthProvider();
    const auth = getAuth(app);
  
    return {app:app, provider:provider, auth: auth};
  }

  export function githubAuthentication(){
      
      // Initialize Firebase
      const app = initializeApp(config());
    
      //const provider = new TwitterAuthProvider();
      const provider = new GithubAuthProvider();
      const auth = getAuth(app);
    
      return {app:app, provider:provider, auth: auth};
  }

export function googleSignIn(){   

    const auth_values = authentication();
    // const app = auth_values.app;
    const provider = auth_values.provider;
    const auth = auth_values.auth;
    // To apply the default browser preference instead of explicitly setting it.
    auth.useDeviceLanguage();

   signInWithRedirect(auth, provider);
    
}

export function githubSignIn(){

  const auth_values = githubAuthentication();
  // const app = auth_values.app;
  const provider = auth_values.provider;
  const auth = auth_values.auth;
  auth.useDeviceLanguage();

 signInWithRedirect(auth, provider);

}

export async function googleSignIn_verification(token,photoURL,displayName){
  
    let payload = {
      subject:"google_signup",
      token: token,
      photoURL : photoURL,
      displayName: displayName,
      country: await get()
    };
    const url = api_link();

  try{
    const resp = await axios.post(`${url}`,payload)

    console.log('From request: ',resp.data);
    
    return resp.data;
    

  }catch(err){
    console.log(err);
  }

}


